import { Injectable, Injector } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, Command } from '../../../core/model/command';
import { Observable } from 'rxjs';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { LeaseAgreementDocumentFormComponent } from '../../component/lease-agreement-document-form/lease-agreement-document-form.component';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { RentalObjectDocumentFormComponent } from '../../component/rental-object-document-form/rental-object-document-form.component';

@Injectable()
export class LinkRentalObjectDocumentCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _injector: Injector
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === rentalObjectCommand.linkDocument && command.context;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean | void> {
    if (command instanceof Command) {
      return this._actionService.open(RentalObjectDocumentFormComponent, this._injector, null, command.context, false); // Do not use wide action window for document form
    }
  }
}
